import flatpickr from 'flatpickr';
import { parse } from 'qs';
import User, { USER_STORAGE_KEY_MAP } from 'shared/storage/user';
import { div } from 'client/javascript/util/dom_utils';
import { varsFromServer } from 'client/javascript/client_side_injection_vars';
import { getDatePickerLocale } from 'client/javascript/date_picker/localization';
import { __ } from 'client/javascript/messages';

export default async function initFlatpickr({ onChange, input, appendTo, disable }) {
  const queryString = window.location.search;
  const queryParams = parse(queryString, { ignoreQueryPrefix: true });
  const defaultDate = queryParams.date || queryParams.start_date || User.getValue(USER_STORAGE_KEY_MAP.startDateFilter);
  const disableFn = disable ? date => disable(date, varsFromServer.building.countryISO) : () => {};
  const locale = await getDatePickerLocale();

  const datePicker = flatpickr(input, {
    appendTo,
    minDate: 'today',
    allowInput: true,
    defaultDate,
    nextArrow: '➝',
    prevArrow: '➝',
    disable: [disableFn],
    onChange,
    locale
  });

  const clearEl = div({ className: 'search-clear hidden', id: 'search-clear__date', html: __('Clear') });
  document.querySelector('.flatpickr-calendar').appendChild(clearEl);

  return datePicker;
}
